function range(start, end) {
    const length = end - start + 1;
    return Array.from({ length }, (_, index) => index + start);
}
export function paginate(currentPage, total, siblings = 1, boundaries = 1) {
    const totalPageNumbers = siblings * 2 + 3 + boundaries * 2;
    if (currentPage > total || siblings <= 0 || boundaries <= 0) {
        return [];
    }
    if (totalPageNumbers >= total) {
        return range(1, total);
    }
    const leftSiblingIndex = Math.max(currentPage - siblings, boundaries);
    const rightSiblingIndex = Math.min(currentPage + siblings, total - boundaries);
    const shouldShowLeftDots = leftSiblingIndex > boundaries + 2;
    const shouldShowRightDots = rightSiblingIndex < total - (boundaries + 1);
    if (!shouldShowLeftDots && shouldShowRightDots) {
        const leftItemCount = siblings * 2 + boundaries + 2;
        return [...range(1, leftItemCount), null, ...range(total - (boundaries - 1), total)];
    }
    if (shouldShowLeftDots && !shouldShowRightDots) {
        const rightItemCount = boundaries + 1 + 2 * siblings;
        return [...range(1, boundaries), null, ...range(total - rightItemCount, total)];
    }
    return [
        ...range(1, boundaries),
        null,
        ...range(leftSiblingIndex, rightSiblingIndex),
        null,
        ...range(total - boundaries + 1, total),
    ];
}
export function mobilePaginate(currentPage, totalPages, siblings = 2) {
    const maxPages = siblings * 2 + 1;
    if (currentPage > totalPages || siblings <= 0) {
        return [];
    }
    if (maxPages > totalPages) {
        return [...range(1, totalPages)];
    }
    if (currentPage - siblings <= 0) {
        return [...range(1, maxPages)];
    }
    if (totalPages - currentPage <= siblings) {
        return [...range(totalPages - (maxPages - 1), totalPages)];
    }
    return [...range(currentPage - siblings, currentPage + siblings)];
}
